/*-----------------------------------------------------------------------------------

    Theme Name: Admin - Administrator Template
    Description: Administrator Template
    Author: jlqm
    Version: 1.0

    /* ----------------------------------

    JS Active Code Index

        01. Scripts
        02. Bootstrap components
        03. Quill editor

    ---------------------------------- */

    // require('select2');

    import Quill from 'quill';

    (function($) {

        $(function() {

            /*------------------------------------
                01. Scripts
            --------------------------------------*/

            $('[data-sidebarCollapse]').on('click', function () {
                $('#sidebar').toggleClass('active');
                $('.sidebar-overlay').toggleClass('active');
            });

            $('input[type="file"]').on('change', function(e){
                let file = e.target.files[0];
                let fileName = file ? file.name : 'Seleccionar archivo';
                $('.custom-file-label').html(fileName);
            });

            /*
            $('[data-datepicker]').datepicker({
                format: 'yyyy-mm-dd',
                language: 'es'
            });
            */

            $(document).on('submit', '[data-record-delete]', function() {
                if (confirm('¿Deseas eliminar el registro de forma permanente?')) {
                    $('[data-record-delete]').find('[type="submit"]').prop('disabled', true);
                    let $btn = $(this).find('[type="submit"]');
                    $btn.addClass('disabled');
                    $btn.html(`<i class="fas fa-cog fa-spin"></i>`);
                    return true;
                }
                return false;
            });

            $(document).on('submit', '[data-record-supplier-authorize]', function() {
                if (confirm('El Staff será marcado como aprobado y su cuenta será habilitada, ¿Deseas continuar?')) {
                    $('[data-record-supplier-authorize]').find('[type="submit"]').prop('disabled', true);
                    let $btn = $(this).find('[type="submit"]');
                    $btn.addClass('disabled');
                    $btn.html(`<i class="fas fa-cog fa-spin"></i>`);
                    return true;
                }
                return false;
            });

            $('a[data-form-server]').on('click', function() {
                let $btn = $(this);
                let btnText = $btn.html();
                $btn.addClass('disabled');

                //let newBtnText = btnText;

                $(this).html(`<i class="fas fa-cog fa-spin"></i>`);
            });


            $('[data-form-batch-actions-delete-trigger]').on('click', function() {
                if (confirm('¿Deseas eliminar los registros de forma permanente?')) {

                    let $form = document.getElementById('form-batch-actions-delete');
                    $form.submit();

                    let $btn = $(this);
                    $btn.addClass('disabled');

                    $btn.html(`<i class="fas fa-cog fa-spin"></i> Eliminando..`);

                    return true;
                }

                return false;
            });

            $(document).on('submit', '[data-form-server]', function() {
                //NProgress.start();
                let $btn = $(this).find('[type="submit"]');
                let btnText = $btn.text().trim();
                $btn.prop('disabled', true);

                let newBtnText = '';
                let icon = 'fa-cog';

                switch(btnText) {
                    case 'Guardar':
                        newBtnText = 'Guardando..';
                        break;
                    case 'Actualizar':
                        newBtnText = 'Actualizando..';
                        icon = 'fa-sync';
                        break;
                    case 'Acceder':
                        newBtnText = 'Cargando..';
                        break;
                    case 'Enviar':
                        newBtnText = 'Enviando..';
                        break;
                    default:
                        newBtnText = 'Procesando..';
                        break;
                }

                $(this).find('[type="submit"]').html(`<i class="fas ${icon} fa-spin"></i> ${newBtnText}`);
            });

            $('.select2').each(function () {
                $(this).select2({
                    theme: 'bootstrap4',
                    width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
                    placeholder: $(this).data('placeholder'),
                });
            });

            $('.selectMultiple').each(function () {
                $(this).select2({
                    theme: 'classic',
                    width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
                    placeholder: $(this).data('placeholder'),
                    allowClear: Boolean($(this).data('allow-clear')),
                    closeOnSelect: !$(this).attr('multiple'),
                    tags: true,
                    tokenSeparators: [',', ' ']
                });
            });

            $(document).on('change', '#product-name', function() {
                $('.name-product-input').addClass('d-none');
                $('#name-product-'+ $(this).val()).removeClass('d-none');
            });


            /*------------------------------------
                03. Bootstrap components
            --------------------------------------*/

            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new window.bootstrap.Tooltip(tooltipTriggerEl)
            })


            /*------------------------------------
                03. Quill editor
            --------------------------------------*/

            $('.quill-editor').each(function(i, el) {
                var el = $(this), id = 'quilleditor-' + i, val = el.val(), editor_height = 150;
                var div = $('<div/>').attr('id', id).css('height', editor_height + 'px').html(val);

                el.addClass('d-none');
                el.parent().append(div);

                var quill = new Quill('#' + id, {
                    modules: {
                        toolbar: [
                            ['bold', 'italic'],
                            ['link', 'code-block'],
                            [{ list: 'ordered' }, { list: 'bullet' }]
                        ]
                    },
                    theme: 'snow'
                });

                quill.on('text-change', function() {
                    el.html(quill.root.innerHTML);
                });
            });

        })

    })(jQuery);
